module.exports = __webpack_public_path__ + "static/Peek-e05042a12d7e1b29b07a564abb4f348c.svg";